import React, { useCallback, useContext, useEffect, useState } from 'react';
import settings from '~/settings.js';

const RecaptchaContext = React.createContext();

function loadScript(onLoad) {
  if (!settings.recaptchaKey) {
    return;
  }

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.google.com/recaptcha/enterprise.js?render=${settings.recaptchaKey}`;
  script.onload = onLoad;

  document.body.appendChild(script);
}

function RecaptchaProvider({ children }) {
  const [isLoaded, setIsLoaded] = useState(false);
  const [isReady, setIsReady] = useState(false);

  // Load the script and initial settings
  useEffect(() => loadScript(() => setIsLoaded(true)), []);

  useEffect(() => {
    if (!isLoaded) return;
    grecaptcha.enterprise.ready(() => setIsReady(true));
  }, [isLoaded]);

  const getToken = useCallback(
    async (action) => {
      if (!isReady) return null;
      return await grecaptcha.enterprise.execute(settings.recaptchaKey, { action });
    },
    [isReady],
  );

  const value = { getToken };

  return <RecaptchaContext.Provider value={value}>{children}</RecaptchaContext.Provider>;
}

function useRecaptcha() {
  return useContext(RecaptchaContext);
}

export { RecaptchaContext, useRecaptcha, RecaptchaProvider };
